import styled from 'styled-components';

import { Spacing } from 'enable-ui';

import { COLOR_CONFIG } from 'constants/color';

export const BorderContainer = styled(Spacing)`
  border: 1px solid rgba(0, 0, 0, 0.15);
  border-radius: 16px;
  padding: 16px;
`;

export const TagBorder = styled.div`
  border: 1px solid ${COLOR_CONFIG['black-out']};
  background: ${COLOR_CONFIG['black-out']};
  padding: 2px 8px;
  border-radius: 6px;
`;
